
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PerformoSettings, Workorder } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    settings: 'settings'
  })
})
export default class StatusStepperComponent extends Vue {
  @Prop({ required: true })
  private order!: Workorder;
  private settings!: PerformoSettings;

  get orderReactive() {
    return this.order;
  }

  private get orderStatusIsCompleteSubStatus() {
    if (this.orderReactive.orderStatus && this.settings.completeSubStatuses) {
      return this.settings.completeSubStatuses.includes(
        this.orderReactive.orderStatus
      );
    } else return false;
  }

  private get orderStatusIsOpenSubStatus() {
    if (this.orderReactive.orderStatus && this.settings.openSubStatuses) {
      return this.settings.openSubStatuses.includes(
        this.orderReactive.orderStatus
      );
    } else return false;
  }

  private submittedOrDefault(item: Workorder) {
    if (item.orderStatus === 'Open' && item.orderNumber === 'REQ') {
      return 'submitted';
    } else {
      return 'notactive'; // default gray
    }
  }

  private openOrDefault(item: Workorder) {
    if (
      (item.orderStatus === 'Open' || this.orderStatusIsOpenSubStatus) &&
      item.orderNumber !== 'REQ'
    ) {
      return 'open';
    } else if (item.orderStatus === 'Hold' && item.orderNumber !== 'REQ') {
      return 'hold';
    } else {
      return 'notactive'; // default gray
    }
  }

  private completeOrDefault(item: Workorder) {
    if (
      item.orderStatus === 'Complete' ||
      this.orderStatusIsCompleteSubStatus
    ) {
      return 'complete';
    } else if (item.orderStatus === 'DNC') {
      return 'dnc';
    } else if (item.orderStatus === 'Denied') {
      return 'denied';
    } else {
      return 'notactive'; // default gray
    }
  }
}
